import { ChangeDetectionStrategy, ChangeDetectorRef, Component, DestroyRef, OnInit, REQUEST, inject } from '@angular/core';
import { CommonModule, Location } from '@angular/common';
import { MainGridComponent } from '@knorr-bremse-portals/ngx-components/components/main-grid';
import { TableComponent } from '@knorr-bremse-portals/ngx-components/components/table';
import { SettingsService } from '../../../app/providers/settings.service';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { EMPTY, filter, startWith } from 'rxjs';
import { BaseLocationService } from '../../providers/base-location.service';

@Component({
    imports: [CommonModule, MainGridComponent, TableComponent],
    templateUrl: './not-found-page.component.html',
    styleUrls: ['./not-found-page.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NotFoundPageComponent implements OnInit {

    protected url!: string;
    protected time = new Date();
    protected request = inject(REQUEST);

    private baseLocation = inject(BaseLocationService);
    private location = inject(Location);

    private route = inject(ActivatedRoute);
    private router = inject(Router);
    private settings = inject(SettingsService);
    private destroyRef = inject(DestroyRef);
    private cdr = inject(ChangeDetectorRef);

    public ngOnInit(): void {
      const region = this.route.snapshot.paramMap.get('region');
      this.settings.setRegionCode(region);

      this.router.events.pipe(
        filter((e): e is NavigationEnd => e instanceof NavigationEnd),
        startWith(EMPTY),
        takeUntilDestroyed(this.destroyRef),
      ).subscribe(() => {
        this.url = `${this.baseLocation.origin}${this.location.path(true)}`;
        this.time = new Date();
        this.cdr.markForCheck();
      });
    }

    protected getReferer(): string {
      if (this.request) {
        return this.request.headers.get('referer') || '';
      }

      return document.referrer;
    }

}
